import { render } from "./index.vue?vue&type=template&id=b42c4260&scoped=true&ts=true"
import script from "./component.ts?vue&type=script&lang=ts"
export * from "./component.ts?vue&type=script&lang=ts"

import "./style.sass?vue&type=style&index=0&id=b42c4260&lang=sass&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b42c4260"]])

export default __exports__